<script setup>
import { withQuery } from "ufo";
import moment from "moment-timezone";

moment.tz.setDefault("Asia/Jakarta");

const deleteDialog = ref(false);

definePage({
  meta: {
    layout: "default",
  },
});
const pageTitle = "Data Merchant";

const route = useRoute();
const router = useRouter();

const breadCrumbs = [
  {
    title: "Dashboard",
    to: "/admin/dashboard",
  },
  {
    title: "Master Data",
    to: null,
  },
  {
    title: pageTitle,
    to: "/admin/merchant",
  },
  {
    title: route.params.id,
    to: null,
  },
];

const { data: dataQuery } = await useApi(
  withQuery("/cms/merchant/" + route.params.id, {
    method: "GET",
  })
);
var data = dataQuery ? dataQuery.value?.data : [];

const statuses = [
  {
    title: "Onboarding",
    value: 1,
  },
  {
    title: "In Service",
    value: 2,
  },
  {
    title: "Suspended",
    value: 3,
  },
  {
    title: "Withdrawal",
    value: 4,
  },
];
const transferTypes = [
  {
    title: "Bank",
    value: 1,
  },
  {
    title: "Credit",
    value: 2,
  },
];
const settlementFrequencies = [
  {
    title: "Daily",
    value: 1,
  },
  {
    title: "Weekly",
    value: 2,
  },
  {
    title: "Monthly",
    value: 4,
  },
];

const days = [
  {
    title: "Monday",
    value: 1,
  },
  {
    title: "Tuesday",
    value: 2,
  },
  {
    title: "Wednesday",
    value: 3,
  },
  {
    title: "Thursday",
    value: 4,
  },
  {
    title: "Friday",
    value: 5,
  },
  {
    title: "Saturday",
    value: 6,
  },
  {
    title: "Sunday",
    value: 7,
  },
];
// Use
const useItems = [
  {
    title: "Use",
    value: 0,
  },
  {
    title: "Not Use",
    value: 1,
  },
];
const contractPlans = [
  {
    title: "Flat",
    value: 1,
  },
  {
    title: "Percent",
    value: 2,
  },
  {
    title: "Use Both",
    value: 3,
  },
];
const notificationTypes = [
  {
    title: "SMS",
    value: 1,
  },
  {
    title: "Email",
    value: 2,
  },
  {
    title: "Both",
    value: 0,
  },
];
const smsNotificationTypes = [
  {
    title: "Contact Mobile Number",
    value: 1,
  },
  {
    title: "Other Mobile Number",
    value: 0,
  },
];
const emailNotificationTypes = [
  {
    title: "Merchant Email Address",
    value: 1,
  },
  {
    title: "Contact Email Address",
    value: 2,
  },
  {
    title: "Other Email Address",
    value: 0,
  },
];
</script>

<template>
  <VBreadcrumbs :items="breadCrumbs" class="px-0 pt-0 pb-5" />
  <h4 class="text-h4 my-4">{{ pageTitle }} Detail</h4>
  <VRow>
    <VCol class="align-items-stretch" cols="12" lg="12" sm="12">
      <VCard :title="data.name" border class="v-card-data">
        <template #append>
          <VBtn
            :to="{ path: '/admin/merchant/update/' + route.params.id }"
            block
            color="primary"
          >
            <VIcon icon="tabler-pencil" start />
            Edit {{ pageTitle }}
          </VBtn>
        </template>
        <VTable class="text-no-wrap" density="compact">
          <tbody>
            <tr>
              <td>Merchant ID</td>
              <td>{{ data.id }}</td>
            </tr>
            <tr>
              <td>Phone Number</td>
              <td>{{ data.phoneNumber }}</td>
            </tr>
            <tr>
              <td>Email Address</td>
              <td>{{ data.email }}</td>
            </tr>
          </tbody>
        </VTable>
        <VDivider />
        <VCardText>
          <h6 class="text-h6">Merchant Contact Info :</h6>
        </VCardText>
        <VTable class="text-no-wrap" density="compact">
          <tbody>
            <tr>
              <td>Contact mobile number</td>
              <td>{{ data.contactMobileNumber }}</td>
            </tr>
            <tr>
              <td>Contact email address</td>
              <td>{{ data.contactEmail }}</td>
            </tr>
          </tbody>
        </VTable>
      </VCard>
      <VRow class="mt-5">
        <VCol cols="12" lg="6" sm="6">
          <VCard border class="h-100 v-card-data" title="Service Period">
            <VTable class="text-no-wrap" density="compact">
              <tbody>
                <tr>
                  <td>Service start date</td>
                  <td>
                    {{ moment(data.serviceStartDate).format("DD/MM/YYYY") }}
                  </td>
                </tr>
                <tr>
                  <td>Service end date</td>
                  <td>
                    {{ moment(data.serviceEndDate).format("DD/MM/YYYY") }}
                  </td>
                </tr>
              </tbody>
            </VTable>
          </VCard>
        </VCol>
        <VCol cols="12" lg="6" sm="6">
          <VCard border class="h-100 v-card-data" title="Status">
            <VTable class="text-no-wrap" density="compact">
              <tbody>
                <tr>
                  <td>Status</td>
                  <td>{{ statuses[data.status - 1].title }}</td>
                </tr>
              </tbody>
            </VTable>
          </VCard>
        </VCol>
        <VCol cols="12" lg="6" sm="6">
          <VCard border class="h-100 v-card-data" title="Transfer Account">
            <VTable class="text-no-wrap" density="compact">
              <tbody>
                <tr>
                  <td>Transfer type</td>
                  <td>{{ transferTypes[data.transferType - 1].title }}</td>
                </tr>
                <tr>
                  <td>Transfer bank code</td>
                  <td>{{ data.bankCode }}</td>
                </tr>
                <tr>
                  <td>Transfer bank name</td>
                  <td>{{ data.bankName }}</td>
                </tr>
                <tr>
                  <td>Transfer bank branch code</td>
                  <td>{{ data.bankBranchCode }}</td>
                </tr>
                <tr>
                  <td>Transfer bank account</td>
                  <td>{{ data.bankAccount }}</td>
                </tr>
                <tr>
                  <td>Transfer credit account</td>
                  <td>{{ data.creditAccount }}</td>
                </tr>
              </tbody>
            </VTable>
          </VCard>
        </VCol>
        <VCol cols="12" lg="6" sm="6">
          <VCard border class="h-100 v-card-data" title="Settlement Plan">
            <VTable class="text-no-wrap" density="compact">
              <tbody>
                <tr>
                  <td>Settlement report display</td>
                  <td>{{ settlementReport ? "On" : "Off" }}</td>
                </tr>
                <tr>
                  <td>Settlement frequency</td>
                  <td>
                    <AppSelect
                      v-model="data.settlementFrequency"
                      :items="settlementFrequencies"
                      class="v-select-print"
                      readonly
                    />
                  </td>
                </tr>
                <tr>
                  <td>Settlement day</td>
                  <td>{{ data.settlementDay }}</td>
                </tr>
                <tr>
                  <td>Settlement day of the week</td>
                  <td>
                    <AppSelect
                      v-model="data.settlementDayOfTheWeek"
                      :items="days"
                      class="v-select-print"
                      readonly
                    />
                  </td>
                </tr>
                <tr>
                  <td>Settlement method</td>
                  <td>
                    <AppSelect
                      v-model="data.settlementMethod"
                      :items="transferTypes"
                      class="v-select-print"
                      readonly
                    />
                  </td>
                </tr>
                <tr>
                  <td>Last settlement date</td>
                  <td>
                    {{
                      moment(data.lastSettlementDate).format(
                        "DD/MM/YYY HH:SS A"
                      )
                    }}
                  </td>
                </tr>
              </tbody>
            </VTable>
          </VCard>
        </VCol>
        <VCol cols="12" lg="6" sm="6">
          <VCard border class="h-100 v-card-data" title="Notification">
            <VTable class="text-no-wrap" density="compact">
              <tbody>
                <tr>
                  <td>Notification type</td>
                  <td>
                    <AppSelect
                      v-model="data.notificationType"
                      :items="notificationTypes"
                      class="v-select-print"
                      readonly
                    />
                  </td>
                </tr>
                <tr
                  v-show="
                    data.notificationType == 1 || data.notificationType == 0
                  "
                >
                  <td>Sms notification type</td>
                  <td>
                    <AppSelect
                      v-model="data.smsNotificationType"
                      :items="smsNotificationTypes"
                      class="v-select-print"
                      readonly
                    />
                  </td>
                </tr>
                <tr
                  v-show="
                    data.notificationType == 2 || data.notificationType == 0
                  "
                >
                  <td>Email notification type</td>
                  <td>
                    <AppSelect
                      v-model="data.emailNotificationType"
                      :items="emailNotificationTypes"
                      class="v-select-print"
                      readonly
                    />
                  </td>
                </tr>
                <tr>
                  <td>SMS notification propriety</td>
                  <td>
                    {{
                      data.notificationType == 1
                        ? "Yes"
                        : data.notificationType == 2
                        ? "No"
                        : "Yes"
                    }}
                  </td>
                </tr>
                <tr>
                  <td>Email notification propriety</td>
                  <td>
                    {{
                      data.notificationType == 1
                        ? "No"
                        : data.notificationType == 2
                        ? "Yes"
                        : "Yes"
                    }}
                  </td>
                </tr>
              </tbody>
            </VTable>
          </VCard>
        </VCol>
        <VCol cols="12" lg="6" sm="6">
          <VCard border class="h-100 v-card-data" title="Terminal Permission">
            <VTable class="text-no-wrap" density="compact">
              <tbody>
                <tr>
                  <td>Sales</td>
                  <td>
                    {{
                      data
                        ? data.terminalPermission
                          ? data.terminalPermission.sales == 1
                            ? useItems[0].title
                            : useItems[1].title
                          : null
                        : null
                    }}
                  </td>
                </tr>
                <tr>
                  <td>Sales cancel</td>
                  <td>
                    {{
                      data
                        ? data.terminalPermission
                          ? data.terminalPermission.salesCancel == 1
                            ? useItems[0].title
                            : useItems[1].title
                          : null
                        : null
                    }}
                  </td>
                </tr>
                <tr>
                  <td>Reload</td>
                  <td>
                    {{
                      data
                        ? data.terminalPermission
                          ? data.terminalPermission.reload == 1
                            ? useItems[0].title
                            : useItems[1].title
                          : null
                        : null
                    }}
                  </td>
                </tr>
                <tr>
                  <td>Cancel reload</td>
                  <td>
                    {{
                      data
                        ? data.terminalPermission
                          ? data.terminalPermission.cancelReload == 1
                            ? useItems[0].title
                            : useItems[1].title
                          : null
                        : null
                    }}
                  </td>
                </tr>
                <tr>
                  <td>Offline card issue by online</td>
                  <td>
                    {{
                      data
                        ? data.terminalPermission
                          ? data.terminalPermission.offlineCardIssueByOnline ==
                            1
                            ? useItems[0].title
                            : useItems[1].title
                          : null
                        : null
                    }}
                  </td>
                </tr>
                <tr>
                  <td>Offline card issue by offline</td>
                  <td>
                    {{
                      data
                        ? data.terminalPermission
                          ? data.terminalPermission.offlineCardIssueByOffline ==
                            1
                            ? useItems[0].title
                            : useItems[1].title
                          : null
                        : null
                    }}
                  </td>
                </tr>
                <tr>
                  <td>Online card issue</td>
                  <td>
                    {{
                      data
                        ? data.terminalPermission
                          ? data.terminalPermission.onlineCardIssue == 1
                            ? useItems[0].title
                            : useItems[1].title
                          : null
                        : null
                    }}
                  </td>
                </tr>
                <tr>
                  <td>Hybrid card issue</td>
                  <td>
                    {{
                      data
                        ? data.terminalPermission
                          ? data.terminalPermission.hybridCardIssue == 1
                            ? useItems[0].title
                            : useItems[1].title
                          : null
                        : null
                    }}
                  </td>
                </tr>
              </tbody>
            </VTable>
          </VCard>
        </VCol>
        <VCol cols="12" lg="6" sm="6">
          <VCard border class="h-100 v-card-data" title="Contract Plan">
            <VTable class="text-no-wrap" density="compact">
              <tbody>
                <tr>
                  <td>Transaction fee type</td>
                  <td>
                    {{
                      data.feeType == 1
                        ? contractPlans[0].title
                        : data.feeType == 2
                        ? contractPlans[1].title
                        : contractPlans[2].title
                    }}
                  </td>
                </tr>
                <tr>
                  <td>Transaction fee rate</td>
                  <td>{{ data.feeRate }}</td>
                </tr>
              </tbody>
            </VTable>
          </VCard>
        </VCol>
        <VCol cols="12" lg="6" sm="6">
          <VCard border class="h-100 v-card-data" title="Operation Record">
            <VTable class="text-no-wrap" density="compact">
              <tbody>
                <tr>
                  <td>Registration date and time</td>
                  <td>
                    {{ moment(data.createdAt).format("DD/MM/YYYY HH:SS A") }}
                  </td>
                </tr>
              </tbody>
            </VTable>
          </VCard>
        </VCol>
      </VRow>
      <div class="mx-auto text-center">
        <VBtn
          :to="{ path: '/admin/merchant' }"
          class="mt-5 mx-auto text-center"
          color="secondary"
        >
          <VIcon icon="tabler-refresh" start />
          Back to {{ pageTitle }} List
        </VBtn>
      </div>
    </VCol>
  </VRow>
</template>
